export default __webpack_public_path__ + "static/media/TestsPassed.c211a030.png";